import { ExerciseAssetTypename, LinkAssetTypename, QuizAssetTypename, VideoAssetTypename, ChapterAssetTypename } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/LessonChirpService';
import { CatalogLessonResponseTypename } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService';
import { LessonProgressResponseTypename } from '../../../__generated__/chirp/com/hubspot/userprogress/bff/rpc/UserProgressBFFChirpService';
import { convertToSupportedLanguage, fullLanguageNameToCode } from '../../constants/academySupportedLanguages';
export const unwrapLessonChirpError = error => {
  var _error$cause, _error$cause2;
  if (!error) {
    return undefined;
  }
  if (error !== null && error !== void 0 && (_error$cause = error.cause) !== null && _error$cause !== void 0 && (_error$cause = _error$cause.cause) !== null && _error$cause !== void 0 && (_error$cause = _error$cause.cause) !== null && _error$cause !== void 0 && (_error$cause = _error$cause.message) !== null && _error$cause !== void 0 && _error$cause.includes('visibility settings')) {
    return {
      status: 403,
      networkError: Object.assign({
        status: 403
      }, error === null || error === void 0 ? void 0 : error.networkError)
    };
  }
  if (error !== null && error !== void 0 && (_error$cause2 = error.cause) !== null && _error$cause2 !== void 0 && (_error$cause2 = _error$cause2.cause) !== null && _error$cause2 !== void 0 && (_error$cause2 = _error$cause2.cause) !== null && _error$cause2 !== void 0 && (_error$cause2 = _error$cause2.message) !== null && _error$cause2 !== void 0 && _error$cause2.includes('not found')) {
    return {
      status: 404,
      networkError: Object.assign({
        status: 404
      }, error === null || error === void 0 ? void 0 : error.networkError)
    };
  }
  const networkError = error.networkError;
  if (networkError) {
    var _networkError$cause, _networkError$cause2, _networkError$respons, _networkError$respons2;
    const status = networkError.status || networkError.statusCode || ((_networkError$cause = networkError.cause) === null || _networkError$cause === void 0 ? void 0 : _networkError$cause.status) || ((_networkError$cause2 = networkError.cause) === null || _networkError$cause2 === void 0 ? void 0 : _networkError$cause2.statusCode) || ((_networkError$respons = networkError.response) === null || _networkError$respons === void 0 ? void 0 : _networkError$respons.status) || ((_networkError$respons2 = networkError.response) === null || _networkError$respons2 === void 0 ? void 0 : _networkError$respons2.statusCode);
    if (status) {
      return {
        status,
        networkError
      };
    }
    return {
      networkError
    };
  }
  return undefined;
};
export const mapLessonContentTypenameToType = content => {
  switch (content.__typename) {
    case VideoAssetTypename:
      return 'VIDEO';
    case LinkAssetTypename:
      return 'LINK';
    case ExerciseAssetTypename:
      return 'PRACTICAL_EXERCISE_FLOW';
    case QuizAssetTypename:
      return 'QUIZ';
    case ChapterAssetTypename:
      return 'CHAPTER';
    default:
      return undefined;
  }
};
export function mapProfessorDescriptions(professor) {
  const descriptions = Object.entries(professor.descriptions).reduce((acc, [langName, value]) => {
    const code = fullLanguageNameToCode(langName);
    if (code && value !== undefined) {
      acc[code] = value;
    }
    return acc;
  }, {});
  return Object.assign({}, professor, {
    descriptions
  });
}
export function chirpLessonToLessonCardModel(lesson) {
  return Object.assign({}, lesson, {
    duration: lesson.duration || 0,
    language: lesson.language.toUpperCase(),
    isDeprecated: !!(lesson.deprecationFinalDate && lesson.deprecationFinalDate < Date.now()),
    shouldShowDeprecationWarning: false,
    type: 'LESSON',
    __typename: CatalogLessonResponseTypename
  });
}
export function lessonToLessonCardModel({
  lesson,
  progress
}) {
  const language = convertToSupportedLanguage(lesson.language);
  return {
    id: lesson.id,
    internalName: lesson.internalName,
    description: lesson.description,
    name: lesson.name,
    duration: lesson.duration || 0,
    language,
    subCategories: lesson.subCategories,
    hsSoftwareFilters: lesson.hsSoftwareFilters,
    levelFilters: lesson.levelFilters,
    lessonType: lesson.lessonType,
    useCases: lesson.useCases,
    businessObjectives: lesson.businessObjectives,
    visibility: lesson.visibility,
    visibleOnLoggedOutPage: lesson.visibleOnLoggedOutPage,
    featuredHomePage: lesson.featuredHomePage,
    pagePath: lesson.pagePath,
    canonicalUrl: lesson.canonicalUrl,
    previewThumbnailSquareUrl: lesson.previewThumbnailSquareUrl,
    previewThumbnailRectangleUrl: lesson.previewThumbnailRectangleUrl,
    previewThumbnailSquare: lesson.previewThumbnailSquare,
    previewThumbnailRectangle: lesson.previewThumbnailRectangle,
    deprecationWarningDate: lesson.deprecationWarningDate,
    deprecationFinalDate: lesson.deprecationFinalDate,
    deprecationCta: lesson.deprecationCta,
    deprecationMessage: lesson.deprecationMessage,
    isDeprecated: !!(lesson.deprecationFinalDate && lesson.deprecationFinalDate < Date.now()),
    shouldShowDeprecationWarning: !!(lesson.deprecationWarningDate && lesson.deprecationWarningDate < Date.now()),
    seoBadge: lesson.seoBadge,
    headline: lesson.headline,
    titleTag: lesson.titleTag,
    metaDescription: lesson.metaDescription,
    learnings: lesson.learnings,
    personas: lesson.personas,
    seoRelatedTrackIds: lesson.seoRelatedTrackIds,
    seoRelatedLessonIds: lesson.seoRelatedLessonIds,
    seoRelatedContent: lesson.seoRelatedContent,
    seoProfessorIds: lesson.seoProfessorIds,
    type: 'LESSON',
    __typename: CatalogLessonResponseTypename,
    progress
  };
}
const chirpLessonProgressToCardProgress = (lessonProgress, lesson) => {
  const completedContent = lesson.content.filter(c => {
    var _lessonProgress$conte;
    return ((_lessonProgress$conte = lessonProgress.contentProgress.find(p => p.contentId === c.id)) === null || _lessonProgress$conte === void 0 ? void 0 : _lessonProgress$conte.progressType) === 'COMPLETED';
  });
  const completedDuration = completedContent.reduce((sum, c) => {
    if (c.__typename === VideoAssetTypename && c.duration) {
      return sum + c.duration;
    }
    if (c.__typename === ChapterAssetTypename) {
      return sum + c.readingTimeMinutes * 60;
    }
    return sum;
  }, 0);
  const status = lessonProgress.status === 'NOT_STARTED' ? 'NOT_STARTED' : lessonProgress.status === 'COMPLETED' ? 'COMPLETED' : 'IN_PROGRESS';
  return {
    id: lessonProgress.lessonId,
    context: 'INDIVIDUAL',
    language: undefined,
    updatedAt: lessonProgress.updatedAt || 0,
    type: 'LESSON',
    status,
    hidden: false,
    completedPercentage: lessonProgress.progressLevel || 0,
    remainingDuration: (lesson.duration || 0) - completedDuration,
    __typename: LessonProgressResponseTypename
  };
};
export const maybeLessonCardModelWithProgress = ({
  lesson,
  progress
}) => {
  if (!lesson) {
    return undefined;
  }
  const cardProgress = progress ? chirpLessonProgressToCardProgress(progress, lesson) : undefined;
  return lessonToLessonCardModel({
    lesson,
    progress: cardProgress
  });
};